import { render } from "./LastSeen.vue?vue&type=template&id=1bbb1dca"
import script from "./LastSeen.vue?vue&type=script&lang=js"
export * from "./LastSeen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__